// extracted by mini-css-extract-plugin
export default {"teddyInfoHeader":"TeddyInfoCard_teddyInfoHeader__G5Rfs","teddyInfoRow":"TeddyInfoCard_teddyInfoRow__tCgZW","teddyInfoRowText":"TeddyInfoCard_teddyInfoRowText__Ym2V0"};